module.exports = __webpack_public_path__ + "img/friendly-resort-2.196ed444.jpg";